import { useEffect, useState } from "react";

import apiClient from "../api-client";
import { getPlanLimitError } from "../utils/planLimits";
import { PlanLimitDialog } from "./PlanLimitDialog";

/** Abre «mejora tu plan» ante cualquier 403 `plan_feature_required` de la API, en cualquier pantalla. */
export const PlanFeatureRequiredDialog = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const interceptor = apiClient.interceptors.response.use(undefined, (requestError) => {
      const limitError = getPlanLimitError(requestError);
      if (limitError?.kind === "feature") setError(limitError);
      return Promise.reject(requestError);
    });
    return () => apiClient.interceptors.response.eject(interceptor);
  }, []);

  return (
    <PlanLimitDialog
      open={Boolean(error)}
      onClose={() => setError(null)}
      kind="feature"
      detail={error?.detail}
      plans={error?.plans}
    />
  );
};
